type ShouldRefreshPageWrapperDataProps = {
  isNewSearch: boolean;
  isBrowserBackNavigation: boolean;
  /** The same navigation is going to ask the server for the results again. */
  willRedoSearch: boolean;
};

/**
 * Whether a client-side navigation back to the results page has to refetch the page-wrapper data.
 *
 * The refetch is not a read of something already decided: it recomputes the whole config server
 * side, and the experiment-driven parts are resolved from scratch every time, so a request that
 * cannot reach SAAB answers with the control arm. `appShowCsw` is one of those, and in the app -
 * where the results and detail steps share a single document - the back button is what runs this
 * call. Losing the variant there takes the entire header away, because `showHeader` needs
 * `appShowCsw` in the app (see resolveHeaderVisibility), and nothing puts it back for the rest of
 * the document (MPH-1123).
 *
 * A new search has new inputs, so it needs the new config. A back navigation only does when it is
 * going to redo the search anyway: returning to a list that is already loaded changes nothing the
 * config is derived from, which is why that path does not refresh the CSW default values either.
 */
export const shouldRefreshPageWrapperData = ({
  isNewSearch,
  isBrowserBackNavigation,
  willRedoSearch,
}: ShouldRefreshPageWrapperDataProps): boolean => isNewSearch || (isBrowserBackNavigation && willRedoSearch);
